//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
var convert = require("decimal-number-to-words");
import unity from "@/unity/unity";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  name: "invoice",
  // watch: {
  //   search(newVal) {
  //     this.findChaege();
  //   },
  // },
  data(vm) {
    return {
      toggleEnable: false,
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      datefrom: null,
      dateto: null,
      menu: false,
      menu2: false,
      search_status: "",
      search: "",
      setlanguage: language.en,
      defaultlanguage: "en",
      mDataArray: [],
      authorize: [],
      status: ["Draft", "Send", "Approve", "Cashier", "Reject"],
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      headers: [
        {
          text: "Doc No.",
          value: "pettycas_id",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Data Request",
          value: "petty_date",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Emp Name",
          value: "petty_emp",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "petty_amount",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Status",
          value: "petty_status",
          class: "bg-colorth tabletextwhite",
        },

        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
        },
      ],
    };
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.headers = language.en.headertable;
    // this.initialize();
  },
  beforeUpdate() { },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.back();
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    // await this.loaddata();
    this.$hideLoader();
  },
  methods: {
    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.billing_expense_getDataPC_PaginatedV2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          this.search,
          this.search_status,
          this.datefrom,
          this.dateto
        );

        this.dataAll2 = result.data.data;

        for (const [index, item] of this.dataAll2.entries()) {
          if (item.petty_amount != "") {
            item.petty_amount = tolocalestringnumber(item.petty_amount);
          }
        }
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.billing_expense_getDataPC_PaginatedV2(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.USER_ID),
          this.search,
          this.search_status,
          this.datefrom,
          this.dateto
        );

        this.dataAll2 = result.data.data;

        for (const [index, item] of this.dataAll2.entries()) {
          if (item.petty_amount != "") {
            item.petty_amount = tolocalestringnumber(item.petty_amount);
          }
        }
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        const result = await api.billing_expense_getDataPC_PaginatedV2(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          this.search,
          this.search_status,
          this.datefrom,
          this.dateto
        );

        this.dataAll2 = result.data.data;

        for (const [index, item] of this.dataAll2.entries()) {
          if (item.petty_amount != "") {
            item.petty_amount = tolocalestringnumber(item.petty_amount);
          }
        }
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        search,
        search_status,
        datefrom,
        dateto,
     */

      try {
        const result = await api.billing_expense_getDataPC_PaginatedV2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.USER_ID),
          this.search,
          this.search_status,
          this.datefrom,
          this.dateto
        );

        this.dataAll2 = result.data.data;

        for (const [index, item] of this.dataAll2.entries()) {
          if (item.petty_amount != "") {
            item.petty_amount = tolocalestringnumber(item.petty_amount);
          }
        }
        this.mDataArray2 = this.dataAll2;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    findChaege() {
      console.log("findChaege:" + this.search);

      // Filter จาก dataAll2 (ข้อมูลทั้งหมดของหน้าปัจจุบัน)
      this.mDataArray2 = this.dataAll2.filter((item) => {
        let matchSearch = true;
        let matchStatus = true;
        let matchDate = true;

        // เช็ค search text
        if (this.search && this.search.trim() !== "") {
          const searchLower = this.search.toLowerCase();
          matchSearch =
            (item.pettycas_id &&
              item.pettycas_id
                .toString()
                .toLowerCase()
                .includes(searchLower)) ||
            (item.petty_date &&
              item.petty_date.toString().toLowerCase().includes(searchLower)) ||
            (item.petty_emp &&
              item.petty_emp.toLowerCase().includes(searchLower)) ||
            (item.petty_amount &&
              item.petty_amount
                .toString()
                .toLowerCase()
                .includes(searchLower)) ||
            (item.petty_status &&
              item.petty_status.toLowerCase().includes(searchLower));
        }

        // เช็ค status
        if (this.search_status && this.search_status !== "") {
          matchStatus = item.petty_status === this.search_status;
        }

        // เช็ค date range
        if (this.datefrom && this.dateto) {
          matchDate =
            item.date_S >= this.datefrom && item.date_S <= this.dateto;
        }

        return matchSearch && matchStatus && matchDate;
      });
    },

    async loaddata() {
      const res_data = await api.getDataPC(
        localStorage.getItem(server.USER_ID)
      );
      console.log("test load data");
      console.log(res_data.data.data);
      this.dataAll2 = res_data.data.data;

      for (const [index, item] of this.dataAll2.entries()) {
        if (item.petty_amount != "") {
          item.petty_amount = tolocalestringnumber(item.petty_amount);
        }
      }
      this.mDataArray2 = this.dataAll2;

      this.$hideLoader();
    },

    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },

    async openPC(data) {
      console.log(data);
      if (data.status == 0) {
        this.$router.push(`/petty-cash/Edit/${data.id}`);
      } else if (data.status == 1) {
        this.$router.push(`/petty-cash/send/${data.id}`);
      } else if (data.status == 2) {
        this.$router.push(`/petty-cash/approve/${data.id}`);
      } else if (data.status == 3) {
        this.$router.push(`/petty-cash/cashier/${data.id}`);
      } else if (data.status == 4) {
        this.$router.push(`/petty-cash/reject/${data.id}`);
      } else if (data.status == 5) {
        this.$router.push(`/petty-cash/reject_account/${data.id}`);
      } else {
        return;
      }
      //
    },
  },
};
